export default __webpack_public_path__ + "static/media/img-video-5.20c3daee.png";